import { Avatar, styled } from '@mui/material'

type TicketTypeGroupLabelProps = {
  name: string
  iconUrl?: string
}

// チケット管理表の選択肢のグループ見出し。どのチケットタイプかをアイコンでも示す。
export const TicketTypeGroupLabel = ({
  name,
  iconUrl,
}: TicketTypeGroupLabelProps) => (
  <Root>
    {iconUrl && <TicketTypeIcon variant="circular" src={iconUrl} />}
    {name}
  </Root>
)

const Root = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})
const TicketTypeIcon = styled(Avatar)({
  width: '16px',
  height: '16px',
  flexShrink: 0,
})
